import { Component, HostBinding, Input, OnChanges } from '@angular/core';

import { DartsGameScore, EventModel, EventScoreboard } from '@frontend/sports/betting-offer/feature/model';
import { SitecoreEventDetailsConfig } from '@frontend/sports/common/client-config-data-access';

@Component({
    selector: 'ms-darts-scoreboard',
    templateUrl: 'darts-scoreboard.html',
})
export class DartsScoreboardComponent implements OnChanges {
    @Input() event: EventModel;
    @Input() scoreboard: EventScoreboard;
    @Input() isNewEDPScoreboard = false;
    @HostBinding('class') className = 'set-game darts';
    score: DartsGameScore;
    legsScore: number[];
    setsScore: number[];
    oneEightysScore: number[];

    constructor(public sitecoreEventDetails: SitecoreEventDetailsConfig) {}

    ngOnChanges(): void {
        this.score = this.event.scoreboard.getScore<DartsGameScore>()!;
        this.setsScore = [this.score.participant1, this.score.participant2];
        this.legsScore = [this.score.legs.participant1, this.score.legs.participant2];
        this.oneEightysScore = [this.score.hundredEighties.participant1, this.score.hundredEighties.participant2];
    }
}
